import {RecordedUserProductsResponse} from '../../components/modal/adduserdialog/user-products.model';
import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ApiService } from '../api/api.service';
// @ts-ignore
import { Router } from '@angular/router';
import Avatar from 'avatar-initials';
import { AppSettings } from '../../app.settings';
import { SessionService } from '../session/session.service';
import { TeamCompanyUsersService } from '../teamcompanyusers/teamcompanyusers.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../../components/snackbar/snackbar.component';
import {
  ADMIN_HANDOFF_VERSION,
  AdminHandoffSelection,
  buildHandoffUrl,
  buildLegacyHandoffUrl,
  handoffFailureCategory,
  HANDOFF_FAILURE_MESSAGE,
  HandoffWindowBlockedError,
  InvalidHandoffResponseError,
  parseAdminHandoffResponse,
} from '../../helpers/handoff-url.helper';
const LOCAL_TEAM_ADMIN_ORIGIN = 'http://localhost:4200';
const LOCAL_V3APP_ORIGIN = 'http://localhost:4000';

interface SuccessResponse<T> {
  success: true;
  data: T;
}

interface FailureResponse {
  success: false;
  error: string;
}

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  ME_UPDATE_TIME = 100;

  private reload = true;
  private reloadAvatar = false;
  private meObservable: BehaviorSubject<any>;
  private isIntegrationAdmin = AppSettings.isIntegration();
  private teamCompaniesCache: any[] | null = null;
  private teamCompaniesCacheUserId = '';
  private teamCompaniesLoadPromise: Promise<any[]> | null = null;

  constructor(
    private apiService: ApiService,
    protected restangular: Restangular,
    private sessionService: SessionService,
    private teamCompanyUsersService: TeamCompanyUsersService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.meObservable = new BehaviorSubject(null);
    if (!this.isIntegrationAdmin) {
      setInterval(() => {
        if (this.reload && apiService.isAuthenticated()) {
          this.reload = false;
          this.restangular
            .one('me')
            .get()
            .toPromise()
            .then((data: any) => {
              if (data.user.isActivatedUser === 0) {
                this.sessionService.logout();
                this.router.navigate(['login']);
              }
              if (this.reloadAvatar) {
                data.user.avatar =
                  data.user.avatar + '?rand=' + Math.random().toString(36).substring(7);
              }
              this.meObservable.next(data);
            })
            .catch(() => {
              this.reload = true;
            });
        }
      }, this.ME_UPDATE_TIME);
    }
  }

  getRecordedProducts(userId: string): Promise<RecordedUserProductsResponse> {
    return this.restangular.one('vendors/admin/users', userId).one('products').get().toPromise();
  }

  me(): any {
    return this.meObservable.getValue();
  }

  // isChild(id?: string): boolean {
  //   if (id) {
  //     return this.lookupFamilyMember(id).permissionLevel === 1;
  //   }
  //   const me = this.me();
  //   return (me && me.user) ? me.user.permissionLevel === 1 : false;
  // }
  //
  // isParent(): boolean {
  //   const me = this.me();
  //   return (me && me.user) ? me.user.permissionLevel === 8 : false;
  // }

  isAdmin(): boolean {
    const me = this.me();
    return me && me.user ? me.user.permissionLevel > 8 : false;
  }

  // isCoparent(): boolean {
  //   const me = this.me();
  //   if (!me && !me.user && !me.family) {
  //     return false;
  //   }
  //   return me.user.permissionLevel === 8 && me.family.ownerId !== me.user.id;
  // }

  getCurrentUserId(): string {
    return this.me() ? this.me().user.id : '';
  }

  // getCurrentFamilyId(): string {
  //   return this.me() ? this.me().family.id : '';
  // }

  getCurrentEmail(): string {
    return this.me() ? this.me().user.email : '';
  }

  // isMemberCoparent(member: any): boolean {
  //   const me = this.me();
  //   return member.userType === 'parent' && member.userId !== me.family.ownerId;
  // }
  //
  // public getFamilyOwnerId(): string {
  //   return this.me().family.ownerId;
  // }
  //
  // public clearAndReloadMe(): void {
  //   this.meObservable.next(undefined);
  //   this.reloadMe();
  // }

  public reloadMe(reloadAvatar = false): void {
    this.reload = true;
    this.reloadAvatar = true;
    this.clearTeamCompaniesCache();
  }

  public meSubscribe(response: any): Subscription {
    return this.meObservable.subscribe(response);
  }

  // isOnboardingCompleted(): any {
  //   return this.me().family;
  // }

  public lookupFamilyMember(id: string): any {
    const me = this.me();
    if (me && me.user.id === id) {
      return me.user;
    }
    return me ? me.usersFamily.find((member: any) => member.userId === id) : '';
  }

  public setPhoneNumber(phoneNumber: string, familyId = '', userId = ''): Promise<any> {
    const me = this.me();
    if (familyId !== '') {
      return this.restangular
        .one('families', familyId)
        .one('users', userId)
        .one('phoneNumbers', phoneNumber)
        .customPUT()
        .toPromise();
    } else {
      return this.restangular
        .one('users', me.user.id)
        .one('phoneNumbers', phoneNumber)
        .customPUT()
        .toPromise();
    }
  }

  public removePhoneNumber(phoneNumber: string): Promise<any> {
    const me = this.me();
    return this.restangular
      .one('users', me.user.id)
      .one('phoneNumbers', phoneNumber)
      .remove()
      .toPromise();
  }

  public removePhoneNumberByUserId(userId: string, phoneNumber: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('phoneNumbers', phoneNumber)
      .remove()
      .toPromise();
  }

  public setAvatar(image: any): Promise<any> {
    const me = this.me();
    return this.restangular
      .one('users', me.user.id)
      .all('avatar')
      .customPUT(image, undefined, undefined, { 'content-type': 'image/*' })
      .toPromise();
  }

  public setPassword(userId: string, password: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('password')
      .customPUT({ password, passwordConfirmation: password })
      .toPromise();
  }

  public setPartner(userId: string, partnerId: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('partner')
      .customPATCH({ partnerId })
      .toPromise();
  }

  public sendPasswordReset(email: string): Promise<any> {
    return this.restangular
      .one('public')
      .one('users')
      .one('reset-password')
      .customPOST({ emailOrUsername: email })
      .toPromise();
  }

  public removeAvatar(): Promise<any> {
    const me = this.me();
    return this.restangular.one('users', me.user.id).one('avatar').remove().toPromise();
  }

  public getUserById(userId: string): Promise<any> {
    return this.restangular.one('users', userId).get().toPromise();
  }

  // public setNotificationSettings(email: boolean, sms: boolean, offers: boolean): Promise<any> {
  //   const data = {
  //     emailSetting: +email,
  //     smsSetting: +sms,
  //     offersSetting: +offers
  //   };
  //   const me = this.me();
  //   return this.restangular.one('users', me.user.id).all('notifications-settings').customPUT(data).toPromise();
  // }

  public updateReceiveOffersSetting(userId: string, receiveOffers: number | boolean): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('notifications-settings')
      .one('receiveOffers', receiveOffers ? 1 : 0)
      .customPUT()
      .toPromise();
  }

  public updateReceiveSmsSetting(userId: string, receiveSms: number | boolean): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('notifications-settings')
      .one('receiveSms', receiveSms ? 1 : 0)
      .customPUT()
      .toPromise();
  }

  public updateUser(userId: string, data: any): Promise<any> {
    const me = this.me();
    return this.restangular.one('users', userId).customPATCH(data).toPromise();
  }

  // public requestPasswordReset(userOrEmail: string, phone: string): Promise<any> {
  //   return this.restangular.one('public').one('users').one('reset-password').
  //   customPOST({ emailOrUsername: userOrEmail, phone }).toPromise();
  // }
  //
  // public resetPassword(resetCode: string, password: string, passwordConfirmation: string): Promise<any> {
  //   return this.restangular.one('auth').one('user-password').one('resetPassword', resetCode).
  //   customPUT({ password, passwordConfirmation}).toPromise();
  // }
  //
  // public recoverUsername(email: string, phone: string): Promise<any> {
  //   return this.restangular.one('public').one('users').one('nickname-recovery').customPOST({ email, phone }).toPromise();
  // }

  public queryUsers(query: string, page = 0, limit = 10): Promise<any> {
    return this.restangular
      .one('users')
      .one(this.getCurrentUserId())
      .one(`bymanager?filter=${encodeURIComponent(query)}&page=${page}&limit=${limit}`)
      .getList()
      .toPromise();
  }

  public getSubscriptionDunning(
    filter = '',
    state = '',
    page = 0,
    limit = 25,
  ): Promise<any[]> {
    return this.restangular
      .one('vendors')
      .one('userproducts')
      .one('dunning')
      .one('all')
      .customGET('', { filter, state, page, limit })
      .toPromise();
  }

  public getUsers(
    filter: string,
    isAdminFilter: boolean,
    selectedBrandFilter: string,
    page: number,
    limit: number,
  ): Promise<any> {
    return this.restangular
      .one('users')
      .one(this.getCurrentUserId())
      .one(
        `bymanager?filter=${encodeURIComponent(filter)}&isAdmin=${
          isAdminFilter || ''
        }&partnerId=${selectedBrandFilter}&page=${page}&limit=${limit}`,
      )
      .getList()
      .toPromise();
  }

  // public queryUserById(userId: string): Promise<any> {
  //   return this.restangular.one('users', userId).get().toPromise();
  // }
  //
  // public findFriends(familyId: string, userId: string, contacts: any): Promise<any> {
  //   return this.restangular.one('families', familyId).one('users', userId).one('find').customPOST(contacts).toPromise();
  // }
  //
  // public getRecentUsers(userId: string): Promise<any> {
  //   return this.restangular.one('users', userId).one('recentusers').getList()().toPromise();
  // }
  //
  // getAvatarOld(user: any): string {
  //   if (user.avatar && user.avatar.includes('no_avatar.png')) {
  //     return 'https://ui-avatars.com/api/?size=128&name=' + user.firstName + '%20' + user.lastName;
  //   } else {
  //     return user.avatar;
  //   }
  // }

  getAvatar(user: any, domElement: any): boolean {
    if (user.avatar && user.avatar.includes('no_avatar.png')) {
      const avatar = new Avatar(domElement, {
        useGravatar: false,
        initials: user.firstName
          ? user.firstName?.charAt(0) + user.lastName?.charAt(0)
          : user.email?.charAt(0),
      });
      return true;
    } else {
      domElement.src = user.avatar;
      return user.avatar;
    }
  }

  validatePhoneCode(userId: string, phoneNumber: string, verificationCode: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('phoneNumbers', phoneNumber)
      .one('codeVerification', verificationCode)
      .customPUT()
      .toPromise();
  }

  validateEmailCode(userId: string, code: string): Promise<any> {
    return this.restangular.one('users', userId).one('validatemail', code).customPUT().toPromise();
  }

  // isEmailValidated(userId: string): Promise<any> {
  //   return this.restangular.one('users', userId).one('isemailvalidated').get().toPromise();
  // }

  resendPhoneValidation(userId: string, phoneNumber: string, oldPhone?: string): Promise<any> {
    return this.setPhoneNumberByUserId(userId, phoneNumber).then((result) => {
      if (oldPhone) {
        return this.removePhoneNumberByUserId(userId, oldPhone);
      } else {
        return {};
      }
    });
  }

  confirmPhoneNumber(userId: string, phoneNumber: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('phoneNumbers', phoneNumber)
      .one(
        'confirm',
        this.teamCompanyUsersService.roles.supportAdmin ? 'supportmanager' : 'supportagent',
      )
      .customPUT()
      .toPromise();
  }

  confirmEmail(userId: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('email')
      .one(
        'confirm',
        this.teamCompanyUsersService.roles.supportAdmin ? 'supportmanager' : 'supportagent',
      )
      .customPUT()
      .toPromise();
  }

  // V5 endpoint, handles Cognito too
  updateEmail(userId: string, email: string): Promise<any> {
    return this.restangular
      .one('v5', 'admin')
      .one('users', userId)
      .one('email')
      .customPATCH({ email })
      .toPromise();
  }

  // V5 endpoint, handles Cognito too
  verifyEmail(userId: string): Promise<void> {
    return this.restangular
      .one('v5', 'admin')
      .one('users', userId)
      .one('email', 'verification')
      .customPOST({})
      .toPromise();
  }

  setAlternateEmail(userId: string, email: string): Promise<any> {
    return this.restangular
      .one('v5', 'admin')
      .one('users', userId)
      .one('account-recovery')
      .one('alternate-email')
      .customPUT({ email })
      .toPromise();
  }

  removeAlternateEmail(userId: string): Promise<any> {
    return this.restangular
      .one('v5', 'admin')
      .one('users', userId)
      .one('account-recovery')
      .one('alternate-email')
      .remove()
      .toPromise();
  }

  setPhoneNumberByUserId(userId: string, phoneNumber: string): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('phoneNumbers', phoneNumber)
      .customPUT()
      .toPromise();
  }

  resendEmailValidation(userId?: string, email?: string): Promise<any> {
    return this.restangular
      .one('users', userId || this.getCurrentUserId())
      .one('generatevalidationemail')
      .customPUT({ email })
      .toPromise();
  }

  login(userId: string): Promise<any> {
    return this.restangular.one('admin/userLogin', userId)
      .post(undefined, {handoffVersion: ADMIN_HANDOFF_VERSION})
      .toPromise();
  }

  loginTeamAdmin(userId: string, devMode: boolean = false, func: ((arg: string) => void) | null = null): Promise<void> {
    return this.login(userId)
      .then((data: any) => {
        const selection = this.requireHandoff(data);
        const targetOrigin = devMode ? LOCAL_TEAM_ADMIN_ORIGIN : AppSettings.getAppEndpoint();
        const url = selection.mode === 'opaque'
          ? buildHandoffUrl(targetOrigin, selection.handoff, devMode ? {api: 'localprod'} : {})
          : buildLegacyHandoffUrl(targetOrigin, selection.legacy, devMode ? {api: 'localprod'} : {});
        this.deliverHandoff(url, func);
      })
      .catch((error: any) => this.reportHandoffFailure(error));
  }

  loginUserV3(
    userId: string,
    devMode: boolean = false,
    func: ((arg: string) => void) | null,
  ): Promise<void> {
    return this.login(userId)
      .then((data: any) => {
        const selection = this.requireHandoff(data);
        // A caller that takes the URL itself embeds/opens the app on behalf of support, so the
        // session is launched in support mode. `supportMode` is a public flag, not a credential.
        const extraFlags: Record<string, string> = func ? {supportMode: '1'} : {};
        if (devMode) {
          extraFlags.api = 'localprod';
        }
        const selectedOrigin = selection.mode === 'opaque'
          ? selection.handoff.origin
          : selection.legacy.origin;
        // The backend picks the v3app/partner brand origin; only that validated origin is used.
        const targetOrigin = devMode
          ? LOCAL_V3APP_ORIGIN
          : AppSettings.getV3AppOriginFromUrl(selectedOrigin);
        const url = selection.mode === 'opaque'
          ? buildHandoffUrl(targetOrigin, selection.handoff, extraFlags)
          : buildLegacyHandoffUrl(targetOrigin, selection.legacy, {
            supportMode: !!func,
            api: devMode ? 'localprod' : undefined,
          });
        this.deliverHandoff(url, func);
      })
      .catch((error: any) => this.reportHandoffFailure(error));
  }

  // Legacy is accepted only as an explicit v2 selection, never after an opaque failure.
  private requireHandoff(data: any): AdminHandoffSelection {
    const selection = parseAdminHandoffResponse(data);
    if (!selection) {
      throw new InvalidHandoffResponseError();
    }
    return selection;
  }

  private deliverHandoff(url: string, func: ((arg: string) => void) | null): void {
    if (func) {
      func(url);
    } else if (!window.open(url, '_blank')) {
      throw new HandoffWindowBlockedError();
    }
  }

  // Never echoes the response: a legacy backend can still return credential-bearing fields.
  private reportHandoffFailure(error: any): void {
    const category = handoffFailureCategory(error);
    console.error('Application handoff failed.', {category});
    this.snackBar.openFromComponent(SnackBarComponent, {data: HANDOFF_FAILURE_MESSAGE});
  }

  getCompanies(partnerId: string): Promise<any> {
    return this.restangular
      .one('users', this.getCurrentUserId())
      .one('companies', partnerId)
      .getList()
      .toPromise();
  }

  getBrands(filter?: string): Promise<any> {
    return this.restangular.one('public').one('partners').customGET('', { filter }).toPromise();
  }

  // TODO: Change
  getAllBrands(params?: {
    page: number;
    limit: number;
    filter?: string;
    selectedBrands: string[];
  }): Promise<any> {
    return this.restangular.one('partners').customPOST(params).toPromise();
  }

  getVisibleBrands(): Promise<any> {
    return this.teamCompanyUsersService.getManagers().then((result: any[]) => {
      const isManager = !!result.find(
        (teamAdminUser: { role: string }) => teamAdminUser.role === 'supportmanager',
      );
      return this.restangular
        .one('users', this.getCurrentUserId())
        .one('partners', isManager ? 'supportmanager' : 'supportagent')
        .getList()
        .toPromise();
    });
  }

  enableOrDisableUserMonthlyAllowance(
    teamId: string,
    userEmail: string,
    canReceiveAllowance: 0 | 1,
  ): Promise<any> {
    return this.restangular
      .one('teams', teamId)
      .one('user')
      .one('email', userEmail)
      .one('canReceiveAllowance', canReceiveAllowance)
      .customPUT()
      .toPromise();
  }

  setCustomMonthlyAllowance(
    teamId: string,
    memberEmail: string,
    allowanceAmount: number,
  ): Promise<void> {
    return this.restangular
      .one('teams', teamId)
      .one('user')
      .one('email', memberEmail)
      .one('monthlyAllowance')
      .customPUT({ monthlyAllowance: allowanceAmount })
      .toPromise();
  }

  public getAgents(
    filter: string,
    selectedBrandFilter: string,
    page: number,
    limit: number,
  ): Promise<any> {
    return this.restangular
      .one('users', this.getCurrentUserId())
      .one(`agents?filter=${filter}&partnerId=${selectedBrandFilter}&page=${page}&limit=${limit}`)
      .getList()
      .toPromise();
  }

  updateUserBrand(userId: string, partnerId: string): Promise<any> {
    const body: { partnerId: string } = { partnerId: partnerId || '' };
    return this.restangular.one('users', userId).one('partner').customPATCH(body).toPromise();
  }

  getLogins(userId: string): Promise<any> {
    return this.restangular.one('users', userId).one('logins').getList().toPromise();
  }

  enableUserAccount(userId: string): Promise<any> {
    return this.restangular
      .one('admin')
      .one('users', userId)
      .one('enableAccount')
      .customPUT()
      .toPromise();
  }

  disableUserAccount(userId: string): Promise<any> {
    return this.restangular
      .one('admin')
      .one('users', userId)
      .one('disableAccount')
      .customPUT()
      .toPromise();
  }

  demoteExactSuperadmin(userId: string): Promise<any> {
    return this.restangular.one('users', userId).one('admin').customPATCH({}).toPromise();
  }

  setDemoMode(userId: string, enable: boolean): Promise<any> {
    return this.restangular
      .one('users', userId)
      .one('setdemomode')
      .customPATCH({ isDemo: enable ? 1 : 0 })
      .toPromise();
  }

  listAccounts(page: number, limit: number): Promise<any> {
    return this.restangular.one('users').customGET('', { page, limit }).toPromise();
  }

  searchAccounts(
    filter: string,
    isAdminFilter: boolean,
    isDemoFilter: boolean,
    selectedBrandFilter: string,
    page: number,
    limit: number,
  ): Promise<any> {
    return this.restangular
      .one('users')
      .customGET('', {
        filter: filter || '',
        isAdmin: isAdminFilter || '',
        isDemo: isDemoFilter || '',
        partnerId: selectedBrandFilter,
        page,
        limit,
      })
      .toPromise();
  }

  deleteUserById(userId: string): Promise<any> {
    return this.restangular.one('users', userId).customDELETE().toPromise();
  }

  getUsersLocationValues(
    type: 'city' | 'state',
  ): Promise<SuccessResponse<string[]> | FailureResponse> {
    return this.restangular.one('v5').one('users').one('locations', type).customGET().toPromise();
  }

  getCachedTeamCompanies(): any[] | null {
    const userId = this.getCurrentUserId();
    if (!userId || this.teamCompaniesCacheUserId !== userId || !this.teamCompaniesCache) {
      return null;
    }

    return [...this.teamCompaniesCache];
  }

  async getTeamCompanies(forceRefresh = false): Promise<any[]> {
    const userId = this.getCurrentUserId();
    if (!userId) {
      return [];
    }

    if (!forceRefresh) {
      const cached = this.getCachedTeamCompanies();
      if (cached) {
        return cached;
      }

      if (this.teamCompaniesLoadPromise) {
        return this.teamCompaniesLoadPromise;
      }
    }

    this.teamCompaniesLoadPromise = (async () => {
    try {
      // If there are no company managers, there is no company (for payroll), so return empty.
      // This prevents us from hitting the 400 on `getCompaniesForUser` that occurs when the originally
      // signed up payroll admin user has not yet created a company to be associated to as a manager
      const result = await this.teamCompanyUsersService.getManagers();
      if (!(result?.length > 0)) {
        this.setTeamCompaniesCache(userId, []);
        return [];
      }
      const companies = await this.teamCompanyUsersService.getCompaniesForUser(userId);
      const userCompaniesResponse = companies?.plain?.() || [];
      const normalizedCompanies = Array.isArray(userCompaniesResponse) ? userCompaniesResponse : [];
      this.setTeamCompaniesCache(userId, normalizedCompanies);
      return [...normalizedCompanies];
    } catch (error) {
      const cached = this.getCachedTeamCompanies();
      if (cached) {
        return cached;
      }
      return [];
    } finally {
      this.teamCompaniesLoadPromise = null;
    }
    })();

    return this.teamCompaniesLoadPromise;
  }

  private setTeamCompaniesCache(userId: string, companies: any[]): void {
    this.teamCompaniesCacheUserId = userId;
    this.teamCompaniesCache = Array.isArray(companies) ? [...companies] : [];
  }

  private clearTeamCompaniesCache(): void {
    this.teamCompaniesCache = null;
    this.teamCompaniesCacheUserId = '';
    this.teamCompaniesLoadPromise = null;
  }
}
